import styles from './Checkbox.module.scss';
import { useAppSelector } from '../../../../redux/hooks';
import UncheckedDark from '../../../../assets/images/DarkTheme/UnCheckedIcon.svg';
import CheckedDark from '../../../../assets/images/DarkTheme/CheckedIcon.svg';
import UncheckedLight from '../../../../assets/images/LightTheme/UnCheckedIcon.svg';
import CheckedLight from '../../../../assets/images/LightTheme/CheckedIcon.svg';

interface CheckboxProps {
  checked?: boolean;
  label?: string;
  checkboxHandler?: (checked: boolean) => void;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked = false,
  label = '',
  disabled = false,
  checkboxHandler = () => {},
}) => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const CheckedIcon = currentTheme === 'dark' ? CheckedDark : CheckedLight;
  const UnCheckedIcon = currentTheme === 'dark' ? UncheckedDark : UncheckedLight;

  const onClickHandler = () => {
    if (disabled) return;
    checkboxHandler(!checked);
  };

  return (
    <div className={`${styles.checkbox_wrapper}`}>
      <div className={styles.checkbox_inner_wrapper}>
        <span className={`${styles.checkbox_custom}`} onClick={onClickHandler}>
          <img src={checked ? CheckedIcon : UnCheckedIcon} alt="checkbox" />
        </span>
        <span
          className={`checkbox_label ${styles.checkbox_label} ${checked ? styles.active_lbl : ''}`}
        >
          {label}
        </span>
      </div>
    </div>
  );
};

export default Checkbox;
